import { render, staticRenderFns } from "./CounterBtn.vue?vue&type=template&id=2c045d21"
import script from "./CounterBtn.vue?vue&type=script&lang=js"
export * from "./CounterBtn.vue?vue&type=script&lang=js"
import style0 from "./CounterBtn.vue?vue&type=style&index=0&id=2c045d21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports